import classNames from 'classnames';
import { InsuranceProvider } from '../routes/checklist/insurance-marketplace';
import {
  trackInsuranceMarketplaceVendorClicked,
  trackLemonadeInsuranceMarketplaceVendorClicked
} from '../utils/analytics';
import { Button } from './Button';

interface Props {
  provider: InsuranceProvider;
}

function InsuranceProviderCard({ provider }: Props) {
  const isFromNativeApp = localStorage.getItem('mobile') === 'true';

  const onButtonClick = () => {
    if (provider.name === 'Lemonade') {
      trackLemonadeInsuranceMarketplaceVendorClicked(provider.name);
    }

    trackInsuranceMarketplaceVendorClicked(provider.name);

    if (isFromNativeApp) {
      window.open(provider.url, '_self');
    } else {
      window.open(provider.url, '_blank');
    }
  };

  return (
    <div className="relative w-full p-6 text-sm border border-gray-200 rounded-lg shadow-md md:max-w-xs">
      {provider.logoUri && (
        <img src={provider.logoUri} alt={provider.name} className="max-h-10" />
      )}
      <div className={classNames({ 'mt-4': provider.logoUri })}>
        <p className="font-medium">{provider.heading}</p>
        <p className="mt-1">{provider.subHeading}</p>
      </div>
      <div className="mt-4">
        <Button className="w-full" onClick={onButtonClick}>
          Browse
        </Button>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-blue-600 rounded-bl-lg rounded-br-lg"></div>
    </div>
  );
}

export { InsuranceProviderCard };
